import React, { useMemo, useEffect, useState } from 'react'
import flowRight from 'lodash/flowRight'
// @ts-ignore
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
import { usePermissions } from 'shared'
import { useDispatch } from 'react-redux'
import { Grid } from 'semantic-ui-react'
// @ts-ignore
import { reactForm, FormField } from 'shared/reactForm'
// @ts-ignore
import { GridContainer } from 'shared/StyledComponents'
import { translate } from 'loankeeper-common/helpers'
import { LKButton as LKBaseButton } from 'loankeeper-common/components'
import createAction from 'loankeeper-common/helpers/createAction'

import { REBUILD_SCHEDULE_MODAL, actions } from '../constants'
import { loanRestRShort, loanView } from '../../../../../store/loan'
import { AppDispatch } from 'src/store/index.d'

const trans = (key) => translate(`frm_loan_schedule_adv_rebuild-${key}`)

interface PropTypes {
  modalInstanceName: string
  form: any
  ID: number
  hash: string
  setData: (data: any) => void
}

const RebuildSchedule: React.FC<PropTypes> = ({ modalInstanceName, form, ID, hash, setData }) => {
  const dispatch = useDispatch<AppDispatch>()
  const [loading, setLoading] = useState<null | boolean>(null)

  const { LOAN_SCHEDULE_ADV_REBUILD } = usePermissions()

  useEffect(() => {
    if (loading === null) {
      setLoading(true)

      dispatch(
        loanView({
          page: 'restrshort',
          LoanID: ID,
          HashSum_LoanID_: hash,
        }),
      )
        .then((result) => {
          const { payload } = result

          form.changeValues(payload)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [form])

  const searchOptions = useMemo(
    () => [
      { value: 1, label: trans('opt_keep_pmt') },
      { value: 2, label: trans('opt_keep_term') },
    ],
    [],
  )

  const handleSubmit = () => {
    setLoading(true)

    form.handleSubmit(({ RebuildTypeID, DeferPayables, KeepDates }) => {
      dispatch(
        loanRestRShort({
          LoanID: ID,
          HashSum_LoanID_: hash,
          RebuildTypeID,
          DeferPayables: DeferPayables ? 1 : 2,
          KeepDates: KeepDates ? 1 : 2,
        }),
      )
        .then((result) => {
          if (loanRestRShort.fulfilled.match(result)) {
            dispatch(createAction(actions.FETCH, null, { ID }))

            const { RestrDate } = result.payload as any

            dispatch(
              loanView({
                page: 'schedule',
                LoanID: ID,
                HashSum_LoanID_: hash,
                ActiveOperFlag: 1,
                RestrDate,
              }),
            ).then((response: any) => {
              if (loanView.fulfilled.match(response)) {
                dispatch(
                  loanView({
                    page: 'schedule_restr',
                    LoanID: ID,
                    HashSum_LoanID_: hash,
                    ActiveOperFlag: 1,
                  }),
                ).then((resp) => {
                  if (loanView.fulfilled.match(resp)) {
                    dispatch(LKModalActions.close(REBUILD_SCHEDULE_MODAL))

                    createAction(actions.FETCH_SUCCESS, { oldGraphic: response.payload }, { ID, RestrDate })
                    setData(resp.payload)
                  }
                })
              }
            })
          }
        })
        .finally(() => {
          setLoading(false)
        })
    })
  }

  return (
    <LKModal
      name={modalInstanceName}
      heading={trans('frm_loan_schedule_adv_rebuild')}
      icon="lk"
      size="sm-1"
      footer={
        <LKModal.Footer>
          <LKBaseButton.Okay
            onClick={handleSubmit}
            loading={loading}
            disabled={loading || !LOAN_SCHEDULE_ADV_REBUILD}
          />
          <LKModal.CancelButton disabled={loading} text={translate('frm_default_work_period-cmd_cancel')} />
        </LKModal.Footer>
      }
    >
      <GridContainer>
        <Grid columns={4}>
          <Grid.Row verticalAlign="middle">
            <Grid.Column textAlign="right">{trans('lbl_principal_adv')}</Grid.Column>
            <Grid.Column className="u-flex u-directionRow u-alignCenter">
              <FormField type="number" name="Principal_Advance" form={form} format required />
            </Grid.Column>

            <Grid.Column textAlign="right">{trans('lbl_principal_next')}</Grid.Column>
            <Grid.Column className="u-flex u-directionRow u-alignCenter">
              <FormField type="number" name="Next_Principal" form={form} format required />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid columns={4}>
          <Grid.Row verticalAlign="middle">
            <Grid.Column textAlign="right">{trans('lbl_adv_threshold')}</Grid.Column>
            <Grid.Column className="u-flex u-directionRow u-alignCenter">
              <FormField type="number" name="Adv_Rebuild_Threshold" form={form} format required />
            </Grid.Column>

            <Grid.Column textAlign="right">{trans('lbl_pmt')}</Grid.Column>
            <Grid.Column className="u-flex u-directionRow u-alignCenter">
              <FormField type="number" name="PMT" form={form} format required />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid columns={2}>
          <Grid.Row verticalAlign="middle">
            <Grid.Column className="u-flex u-directionRow u-alignCenter u-paddingTop-25" style={{ width: '100%' }}>
              <FormField type="checkbox" name="DeferPayables" label={trans('chk_defer_payables')} form={form} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Column className="u-flex u-directionRow u-alignCenter">
            <FormField type="text" name="Current_Payables_AsString" form={form} disabled />
          </Grid.Column>
        </Grid>

        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column className="u-flex u-directionRow u-alignCenter" style={{ width: '100%' }}>
              <FormField type="radiogroup" name="RebuildTypeID" form={form} options={searchOptions} vertical />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row verticalAlign="middle">
            <Grid.Column className="u-flex u-directionRow u-alignCenter" style={{ width: '100%' }}>
              <FormField type="checkbox" name="KeepDates" label={trans('chk_keep_existing_dates')} form={form} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </GridContainer>
    </LKModal>
  )
}

const enhance = flowRight(
  reactForm({
    initialValues: {
      Principal_Advance: 0,
      Principal_Next: 0,
      Adv_Rebuild_Threshold: 0,
      Current_Payables_AsString: '',
      PMT: 0,
      DeferPayables: true,
      RebuildTypeID: 1,
      KeepDates: true,
    },
  }),
  LKModalContainer(REBUILD_SCHEDULE_MODAL),
)

export default enhance(RebuildSchedule)
